module.exports = __webpack_public_path__ + "img/denmark-external-causes-male.2b020e04.png";